import React, { useState } from 'react';

import CommonImage from '@/components/CommonImage';

import MultipleTechpackPreview from './MultipleTechpackPreview';
import MultipleUploadTechpack from './MultipleUploadTechpack';

const MultipleTechpackJourney = ({ collectionId, extractionPendingList, MergedFilesCount }) => {
	const [showTechpackPreview, setShowTechpackPreview] = useState([]);
	const [extractionPendingListState, setExtractionPendingListState] = useState(extractionPendingList || []);

	const renderBackButton = () => {
		return (
			<div className="tp-button-container bg-white px-4 d-flex align-items-center justify-content-between">
				<button
					className="button text size32 p-0"
					type="button"
					onClick={() => setShowTechpackPreview([])}
				>
					<CommonImage src="/icons/back-arrow-gray.svg" />
					<span className="semibold-14 gray_dark_01 ml-1">Back</span>
				</button>
				<div className="upload-techpack-button">
					<button className="button text size32 px-0" onClick={() => setShowTechpackPreview([])}>
						<img src={`${process.env.PUBLIC_URL}/icons/add-round.svg`} alt="design" /> Techpack
					</button>
				</div>
			</div>
		);
	};
	return (
		<div>
			{showTechpackPreview.length > 0 && renderBackButton()}
			{showTechpackPreview.length === 0 && (
				<MultipleUploadTechpack
					collectionId={collectionId}
					MergedFilesCount={MergedFilesCount}
					onUpdateBasicInfo={({ productIds, extractionPendingList }) => {
						setShowTechpackPreview(productIds || []);
						setExtractionPendingListState(extractionPendingList || []);
					}}
				/>
			)}
			{showTechpackPreview.length > 0 && (
				<MultipleTechpackPreview
					productIds={showTechpackPreview}
					extractionPendingList={extractionPendingListState}
					MergedFilesCount={MergedFilesCount}
				/>
			)}
		</div>
	);
};

export default MultipleTechpackJourney;
